import { IDesignatedDoctorInformationSource } from "../../../../documaker/domain/format/objects";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IDesignatedDoctorType } from "../IFormatSpecification";

export interface IDesignatedDoctorInformationSourcePropertyEditable {
  designatedDoctorInformationSource(): IPropertyEditable<IDesignatedDoctorInformationSource>;
  getSelectableDesignatedDoctorTypes(): IDesignatedDoctorType[];
}

export function instanceOfIDesignatedDoctorInformationSourcePropertyEditable(instance: any): instance is IDesignatedDoctorInformationSourcePropertyEditable {
  return instance
      && instance.designatedDoctorInformationSource
      && instance.getSelectableDesignatedDoctorTypes
      && instanceOfIPropertyEditable<IDesignatedDoctorInformationSource>(instance.designatedDoctorInformationSource());
}
